import React, { memo, useState } from "react"

// function support_format_webp() {
//   if (typeof document !== "undefined") {
//     const elem = document.createElement("canvas")
//     return elem.toDataURL("image/webp").startsWith("data:image/webp")
//   } else {
//     return false
//   }
// }

const resolutions = [
  //   { media: "(min-width: 1300px)", resolution: "-1536x1536" },
  //   { media: "(min-width: 1024px)", resolution: "-1024x1024" },
  //   { media: "(min-width: 600px)", resolution: "-768x768" },
  //   { media: "(min-width: 300px)", resolution: "-300x300" },
  //   { media: "(min-width: 150px)", resolution: "-300x300" },
  { media: "(min-width: 150px)", resolution: "" },
]

const generateSource = (format, imageData) => {
  const fileExtension = imageData?.split(".").pop()

  if (["png", "jpg", "jpeg"].includes(fileExtension)) {
    return resolutions.map(({ media, resolution }) => (
      <source
        key={resolution}
        srcSet={`${imageData?.replace(
          `.${fileExtension}`,
          `${resolution}.${format}`
        )}`}
        media={media}
        type="image/webp"
      />
    ))
  }
  return null
}

const ImageShow = ({
  imageData,
  alt,
  key,
  pictureclass,
  Children,
  onClick,
  loading = "lazy"
}) => {
  const [hasError, setHasError] = useState(false)
  // const isWebPSupported = support_format_webp()

  if (hasError) {
    return (
      <picture
        className={pictureclass}
        key={key}
        onClick={onClick}
        onKeyDown={onClick}
      >
        <img
          src={imageData || ""}
          alt={alt}
          title={alt}
          loading="lazy"
          width="100%"
          height="100%"
          onError={e => (e.target.src = `/images/placeholder-image.jpg`)}
        />
        {Children}
      </picture>
    )
  }

  return (
    <picture
      className={pictureclass}
      key={key}
      onClick={onClick}
      onKeyDown={onClick}
    >
      {generateSource("webp", imageData)}
      <img
        src={imageData || ""}
        alt={alt}
        title={alt}
        loading={loading}
        width="100%"
        height="100%"
        onError={() => {
          setHasError(true)
        }}
      />
      {Children}
    </picture>
  )
}
export default memo(ImageShow)
